export const name = "BYTE_LENGTH";
export const summary = `Gets the number of \`BYTES\` in a \`STRING\` or \`BYTES\` value.`;
export const reference = `
## BYTE_LENGTH

Gets the number of \`BYTES\` in a \`STRING\` or \`BYTES\` value.

\`\`\`
BYTE_LENGTH(value)
\`\`\`

### Description

Gets the number of \`BYTES\` in a \`STRING\` or \`BYTES\` value, regardless of whether the value is a \`STRING\` or \`BYTES\` type.


### Return type

\`INT64\`


### Examples



\`\`\`
SELECT BYTE_LENGTH('абвгд') AS string_example;

/*----------------*
 | string_example |
 +----------------+
 | 10 |
 *----------------*/
\`\`\`



\`\`\`
SELECT BYTE_LENGTH(b'абвгд') AS bytes_example;

/*----------------*
 | bytes_example |
 +----------------+
 | 10 |
 *----------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
